import { AccordionDetails as NovaAccordionDetails } from '@fme-nova/components'
import {
  AccordionDetailsProps as MuiAccordionDetailsProps,
  default as MuiAccordionDetails,
} from '@mui/material/AccordionDetails'

import { createComponentWrapperWithRef } from '../../theme'

export const AccordionDetails = createComponentWrapperWithRef<MuiAccordionDetailsProps>(
  {
    mui: MuiAccordionDetails,
    nova: NovaAccordionDetails,
  },
  'AccordionDetails',
)
